import request from '@jms/api/request'

const { VITE_APP_API_BASE_URL } = import.meta.env
enum Api {
  DOELOAD_FILE = '/file/download'
}
// 上传图片
export const uploadImage = `${VITE_APP_API_BASE_URL}/web/image/upload?isPersistence=true`

export default class GlobalService {
  /**
   * 下载文件
   * @param data
   * @returns
   */
  static downloadFile(data: Record<string, any>): Promise<any> {
    return request.post(Api.DOELOAD_FILE, data, true)
  }
  /**
   * 获取省市区接口
   * @param data
   * @returns
   */
  static basicsArea(data: any): Promise<any> {
    return request.post('/box/basicsArea/all', data)
  }
  /**
   * 获取快递公司接口
   * @param data
   * @returns
   */
  static expressList(data: any): Promise<any> {
    return request.get('/express/list')
  }
}
